import { defineComponent } from "vue";

/**
 * 渲染 `Message` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Message = defineComponent({
	name: "Message",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M878.03448853 159.9260448H168.8803552a75.86702187 75.86702187 0 0 0-75.776 75.73048853v503.76248854a75.82151147 75.82151147 0 0 0 75.776 75.7304896h41.64266666v112.64a34.13333333 34.13333333 0 0 0 34.13333334 34.13333333h3.2768a34.08782187 34.08782187 0 0 0 24.1208896-10.0124448l136.53333333-136.76088853h469.2195552a75.82151147 75.82151147 0 0 0 75.73048853-75.7304896V235.65653333a75.86702187 75.86702187 0 0 0-75.50293333-75.73048853z m-254.54364373 429.62488853h-330.86577814a34.13333333 34.13333333 0 0 1 0-68.26666666h330.86577814a34.13333333 34.13333333 0 1 1 0 68.26666666z m130.75342186-166.75271146H292.62506666a34.13333333 34.13333333 0 0 1 0-68.26666667h461.6192a34.13333333 34.13333333 0 1 1 0 68.26666667z" />
			</svg>
		);
	},
});

export default Message;
